import { api } from "@/services";

type ResetPasswordRequest = {
  email: string;
  code: string;
  password: string;
  site: "NOVOSITE" | "MICHELIN" | "LingLong" | "LINGLONG" | "BFGOODRICH";
};

type ResetPasswordResponse = {
  status: boolean;
  msgs: string[] | string;
};

async function useResetPassword({
  email,
  code,
  password,
  site
}: ResetPasswordRequest): Promise<
  [Response: ResetPasswordResponse | null, Error: string | null, Loading: boolean]
> {
  let Response = null;
  let RError = null;
  let Loading = true;

  const Controller = new AbortController();

  const MakeRequest = async (): Promise<void> => {
    try {
      const resp: { data: ResetPasswordResponse } = await api.post(`/Auth/ResetPassword`, null, {
        signal: Controller.signal,
        params: {
          email: email,
          site: site,
          code: code,
          password: password
        }
      });
      console.log(resp);
      if (resp.data.status) {
        Response = resp.data;
      } else {
        throw new Error(resp.data.msgs[0]);
      }
    } catch (error) {
      RError = error.message;
    } finally {
      Loading = false;
    }
  };

  await MakeRequest();

  Controller.abort();

  return [Response, RError, Loading];
}

export { useResetPassword };
